var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCalendar = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0306454 14.4375V7H12.2806V14.4375C12.2806 14.8021 12.153 15.112 11.8978 15.3672C11.6426 15.6224 11.3327 15.75 10.9681 15.75H1.34315C0.978562 15.75 0.668666 15.6224 0.413458 15.3672C0.15825 15.112 0.0306454 14.8021 0.0306454 14.4375ZM8.78065 9.07812V10.1719C8.78065 10.3906 8.89002 10.5 9.10877 10.5H10.2025C10.4213 10.5 10.5306 10.3906 10.5306 10.1719V9.07812C10.5306 8.85938 10.4213 8.75 10.2025 8.75H9.10877C8.89002 8.75 8.78065 8.85938 8.78065 9.07812ZM8.78065 12.5781V13.6719C8.78065 13.8906 8.89002 14 9.10877 14H10.2025C10.4213 14 10.5306 13.8906 10.5306 13.6719V12.5781C10.5306 12.3594 10.4213 12.25 10.2025 12.25H9.10877C8.89002 12.25 8.78065 12.3594 8.78065 12.5781ZM5.28065 9.07812V10.1719C5.28065 10.3906 5.39002 10.5 5.60877 10.5H6.70252C6.92127 10.5 7.03065 10.3906 7.03065 10.1719V9.07812C7.03065 8.85938 6.92127 8.75 6.70252 8.75H5.60877C5.39002 8.75 5.28065 8.85938 5.28065 9.07812ZM5.28065 12.5781V13.6719C5.28065 13.8906 5.39002 14 5.60877 14H6.70252C6.92127 14 7.03065 13.8906 7.03065 13.6719V12.5781C7.03065 12.3594 6.92127 12.25 6.70252 12.25H5.60877C5.39002 12.25 5.28065 12.3594 5.28065 12.5781ZM1.78065 9.07812V10.1719C1.78065 10.3906 1.89002 10.5 2.10877 10.5H3.20252C3.42127 10.5 3.53065 10.3906 3.53065 10.1719V9.07812C3.53065 8.85938 3.42127 8.75 3.20252 8.75H2.10877C1.89002 8.75 1.78065 8.85938 1.78065 9.07812ZM1.78065 12.5781V13.6719C1.78065 13.8906 1.89002 14 2.10877 14H3.20252C3.42127 14 3.53065 13.8906 3.53065 13.6719V12.5781C3.53065 12.3594 3.42127 12.25 3.20252 12.25H2.10877C1.89002 12.25 1.78065 12.3594 1.78065 12.5781ZM10.9681 3.5C11.3327 3.5 11.6426 3.6276 11.8978 3.88281C12.153 4.13802 12.2806 4.44792 12.2806 4.8125V6.125H0.0306454V4.8125C0.0306454 4.44792 0.15825 4.13802 0.413458 3.88281C0.668666 3.6276 0.978562 3.5 1.34315 3.5H2.65565V2.1875C2.65565 2.0599 2.6921 1.95964 2.76502 1.88672C2.85617 1.79557 2.96554 1.75 3.09315 1.75H3.96815C4.09575 1.75 4.19601 1.79557 4.26893 1.88672C4.36007 1.95964 4.40565 2.0599 4.40565 2.1875V3.5H7.90565V2.1875C7.90565 2.0599 7.9421 1.95964 8.01502 1.88672C8.10617 1.79557 8.21554 1.75 8.34315 1.75H9.21815C9.34575 1.75 9.44601 1.79557 9.51893 1.88672C9.61007 1.95964 9.65565 2.0599 9.65565 2.1875V3.5H10.9681Z",
    fill: "#2F0A77"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.03125,
    y: 0.75,
    width: 12.25,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "1642699981952/static/media/calendar.8e5c9c9c.svg";
export { ForwardRef as ReactComponent };